<div class="ups-dialog">
    <div class="dialog-header">
        <h2 mat-dialog-title>{{'imprint.title'|translate}} <br>
            UPSV Capital Versicherungsvermittlung GmbH </h2>
    
        <mat-dialog-actions>
        </mat-dialog-actions>
        <button type="button" mat-raised-button class="icon-button close-button" mat-dialog-close>
            <mat-icon>close</mat-icon>
        </button>
    </div>
    <div class="main-div" >
<p>{{ 'imprint.0' | translate }}</p>
<p> {{ 'imprint.1' | translate }}</p>
<p> {{ 'imprint.2' | translate }}</p>
<div> {{ 'imprint.3' | translate }}</div>
<div> {{ 'imprint.4' | translate }}</div>
<div> {{ 'imprint.5' | translate }}</div>
<div> {{ 'imprint.6' | translate }}</div>
<p [innerHtml]="'imprint.7'|translate"></p>
<p> {{ 'imprint.8' | translate }}</p>
<div> {{ 'imprint.9' | translate }}</div>
<div> {{ 'imprint.10' | translate }}</div>
<div> {{ 'imprint.11' | translate }}</div>
<div> {{ 'imprint.12' | translate }}</div>
<p> {{ 'imprint.13' | translate }}</p>
<div> {{ 'imprint.14' | translate }}</div>
<div> {{ 'imprint.15' | translate }}</div>
<div> -{{ 'imprint.16' | translate }}</div>
<div> -{{ 'imprint.17' | translate }}</div>
<div> -{{ 'imprint.18' | translate }}</div>
<div [innerHtml]="'imprint.19'|translate"></div>
</div>
</div>